import React from 'react';
import { FormattedMessage } from 'react-intl';
import { EMPTY_VALUE } from '../../constants';
import { IEnrollment } from '../../types';

// ============================================================================
// Component
// ============================================================================

interface IEnrollmentIdsSectionProps {
    enrollment: IEnrollment;
}

const EnrollmentIdsSection: React.FC<IEnrollmentIdsSectionProps> = ({ enrollment }) => {
    const {
        policyId = '',
        cmsPlanId = '',
    } = enrollment;

    return (
        <div>
            <h4 className="text-uppercase margin-top-0 margin-bottom-2">
                <FormattedMessage id="member.enrollment_list.premiumhistory.enrollmentIDs" />
            </h4>
            <div className="display-flex flex-justify flex-align-center padding-y-1">
                <span className="text-base-dark"><FormattedMessage id="historical.member.applications.assignedPolicyId" /></span>
                <span className="text-base-dark">{policyId || EMPTY_VALUE}</span>
            </div>
            <div className="display-flex flex-justify flex-align-center padding-y-1">
                <span className="text-base-dark"><FormattedMessage id="member.enrollment_list.premiumhistory.CMSPlanId" /></span>
                <span className="text-base-dark">{cmsPlanId || EMPTY_VALUE}</span>
            </div>
        </div>
    );
};

export default EnrollmentIdsSection;
